import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=884b697c&"
import script from "BASE/common/util/util.logo.js?vue&type=script&lang=js&"
export * from "BASE/common/util/util.logo.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports